// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__Gib1p","row":"styles_row__369Uz"};